export const API_BASE_URL = '/API/V1'
export const BASE_URL = 'http://test-datp-env.eba-gpgv7ayh.eu-west-1.elasticbeanstalk.com'

export const GCP_MAPS_API_KEY = 'AIzaSyBVseDa3i0Hf8g1L8qfSrOwOV28OgjWVy0'
export const GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode'

export const FACEBOOK_APP_ID = 'REDACTED'
export const GOOGLE_APP_ID = 'REDACTED'
export const APPLE_CLIENT_ID = 'REDACTED'
export const APPLE_REDIRECT_URL = 'http://test-datp-env.eba-gpgv7ayh.eu-west-1.elasticbeanstalk.com/discover'
export const EMAIL_SCOPE = 'email name'

export const ROLLBAR_KEY = '6b6634472ae248ed8cf126a6b8bb320e'
export const ROLLBAR_ENV = 'production'
export const USERBACK_KEY = 'A-5F2E816dXa1Dd4sgRObW4W54Z'

export const GOOGLE_ANALYTICS_ID = 'G-976EQ0VP69'
export const SUPPORT_EMAIL = 'support@datingacrossthepond.com'

export const BANNER_MESSAGE = 'Refresh if messages doesn’t load.'
export const BANNER_STATUS = true